import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import Dumbo from '../index';
import TextRenderer from '../../../TextRenderer';
import PollAnswerViewer from '../../../DaEditorWrapper/Viewer/PollAnswer';
import s from './Poll.scss';
var Answer = function (_a) {
    var textContent = _a.textContent, image = _a.image, votes = _a.votes, percentvotes = _a.percentvotes;
    return (React.createElement("li", { className: classnames(s['answer'], s['answer-voted']) },
        React.createElement("div", { className: s['answer-row'] },
            image && (React.createElement(Dumbo, { deviation: image, className: s['pollimage'], width: 72, height: 72 })),
            React.createElement(TextRenderer, { htmlExcerptLegacy: true, isPollWithHtmlExcerpt: true, textContent: textContent, className: classnames(s['answer-text'], 'da-editor-poll-thumb'), reactViewer: PollAnswerViewer }),
            React.createElement("div", { className: s['percent'] },
                percentvotes,
                "%")),
        React.createElement("div", { className: s['bar-wrapper'] },
            React.createElement("div", { className: s['bar'], style: { width: percentvotes + "%" } }))));
};
export var VotedAnswers = function (_a) {
    var poll = _a.poll;
    return (React.createElement("ul", { className: classnames(s['voted'], s['answers']) }, poll.answers.map(function (answer) { return (React.createElement(Answer, tslib_1.__assign({}, answer, { key: "answer:" + answer.answerId }))); })));
};
export default VotedAnswers;
//# sourceMappingURL=VotedAnswers.js.map